import { render, staticRenderFns } from "./DealValue.vue?vue&type=template&id=ec67d17a&scoped=true&"
import script from "./DealValue.vue?vue&type=script&lang=js&"
export * from "./DealValue.vue?vue&type=script&lang=js&"
import style0 from "./DealValue.vue?vue&type=style&index=0&id=ec67d17a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec67d17a",
  null
  
)

component.options.__file = "DealValue.vue"
export default component.exports